/**
 * Etichetta leggibile di ogni tipo di notifica (enum `notification_type`).
 * Una tabella sola per web e mobile: la mobile ne aveva una sua con sette
 * tipi, e gli altri comparivano col codice interno («wallet_soglia»).
 */
export const NOTIFICATION_TIPO_LABEL = {
	expiry_alert: 'Alert Scadenza',
	missing_documents: 'Documenti Mancanti',
	pod_anomaly: 'Anomalia POD',
	monthly_report: 'Report Mensile',
	weekly_summary: 'Riepilogo',
	manual: 'Comunicazione',
	system: 'Sistema',
	deadline_acconto: 'Scadenza Acconto',
	deadline_conguaglio: 'Scadenza Conguaglio',
	deadline_rendicontazione: 'Scadenza Rendicontazione',
	deadline_pnrr: 'Scadenza PNRR',
	deadline_pnrr_saldo: 'Saldo PNRR',
	deadline_domanda_gse: 'Domanda GSE',
	deadline_integration_scaduta: 'Integrazione Scaduta',
	deadline_antimafia: 'Scadenza Antimafia',
	antimafia_threshold: 'Soglia Antimafia',
	live_feed_down: 'Feed Interrotto',
	forecast_accuracy_low: 'Accuratezza Previsioni',
	consumption_anomaly: 'Irregolarità Consumi',
	wallet_soglia: 'Wallet - Soglia Superata',
} as const;

export type NotificationTipo = keyof typeof NOTIFICATION_TIPO_LABEL;

/**
 * Etichetta di un tipo di notifica. Un tipo nuovo non ancora in tabella non
 * mostra il codice: «nuovo_tipo» diventa «Nuovo tipo». Una notifica legata a
 * una richiesta del socio è «Richiesta», qualunque tipo abbia nel database
 * (le richieste nascono come `system`, e il badge diceva «Sistema»).
 */
export function notificationTipoLabel(tipo: string, requestId?: string | null): string {
	if (requestId) return 'Richiesta';
	const known = (NOTIFICATION_TIPO_LABEL as Record<string, string>)[tipo];
	if (known) return known;
	const words = tipo.replaceAll('_', ' ').trim();
	return words ? words.charAt(0).toUpperCase() + words.slice(1) : 'Notifica';
}

/**
 * Una notifica generata dal sistema (avvisi, riepiloghi, scadenze, anomalie)
 * e non scritta da qualcuno: né un messaggio manuale né la risposta a una
 * richiesta. Il suo mittente è «Sistema», non il socio a cui si riferisce.
 */
export function isAutomaticNotification(n: { tipo: string; request_id?: string | null }): boolean {
	return n.tipo !== 'manual' && !n.request_id;
}
